export namespace PaymentTypeAdjustments {

    export const PaymentTypeAdjustment = Symbol("PaymentTypeAdjustment");
    export interface PaymentTypeAdjustment {
        [PaymentTypeAdjustment]: boolean;
    }

    export interface PaymentTypeAdjustmentDto {
        $type: string;
        value: PaymentTypeAdjustmentValueDto;
    }

    export interface PaymentTypeAdjustmentValueDto {
        //
    }

    export function serializePaymentTypeAdjustment(action: PaymentTypeAdjustment): PaymentTypeAdjustmentDto {
        if (!action) {
            return null;
        }

        for (let paymentTypeAdjustment of paymentTypeAdjustments) {
            if (paymentTypeAdjustment.isInstanceOf(action)) {
                return {
                    $type: paymentTypeAdjustment.key,
                    value: paymentTypeAdjustment.serialize(action)
                };
            }
        }

        throw new Error("Invalid status type");
    }

    export function deserializePaymentTypeAdjustment(dto: PaymentTypeAdjustmentDto): PaymentTypeAdjustment {
        if (!dto) {
            return null;
        }

        for (let paymentTypeAdjustment of paymentTypeAdjustments) {
            if (paymentTypeAdjustment.key === dto.$type) {
                return paymentTypeAdjustment.deserialize(dto.value);
            }
        }

        throw new Error("Invalid status type");
    }

    export function getPaymentTypeAdjustmentName(status: PaymentTypeAdjustment): string {

        for (let paymentTypeAdjustment of paymentTypeAdjustments) {
            if (paymentTypeAdjustment.isInstanceOf(status)) {
                return paymentTypeAdjustment.name;
            }
        }

        throw new Error("Invalid status type");
    }

    export function createPaymentTypeAdjustment(key: string): PaymentTypeAdjustment {

        for (let paymentTypeAdjustment of paymentTypeAdjustments) {
            if (paymentTypeAdjustment.key === key) {
                return paymentTypeAdjustment.create();
            }
        }

        throw new Error("Invalid paymentTypeAdjustment key");
    }


    export const StripePaymentTypeAdjustment = Symbol("StripePaymentTypeAdjustment");
    export interface StripePaymentTypeAdjustment extends PaymentTypeAdjustment {
        [StripePaymentTypeAdjustment]: boolean;
        FeeAmount: number;
    }

    export function isStripePaymentTypeAdjustment(val: PaymentTypeAdjustment): val is StripePaymentTypeAdjustment {
        return val && (val as StripePaymentTypeAdjustment)[StripePaymentTypeAdjustment] === true;
    }

    export interface StripePaymentTypeAdjustmentValueDto extends PaymentTypeAdjustmentValueDto {
        feeAmount: number;
    }

    export const StripePaymentTypeAdjustmentDefinition: PaymentTypeAdjustmentDefinition = {
        key: "Stripe",
        name: "Stripe",
        isInstanceOf: (paymentTypeAdjustment: PaymentTypeAdjustment) => isStripePaymentTypeAdjustment(paymentTypeAdjustment),
        create: (): StripePaymentTypeAdjustment => {
            return {
                [PaymentTypeAdjustment]: true,
                [StripePaymentTypeAdjustment]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentTypeAdjustment: StripePaymentTypeAdjustment): StripePaymentTypeAdjustmentValueDto => {
            return {
                feeAmount: paymentTypeAdjustment.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeAdjustmentDefinition, dto: StripePaymentTypeAdjustmentValueDto) {
            const stripe = this.create() as StripePaymentTypeAdjustment;
            stripe.FeeAmount = dto.feeAmount;
            return stripe;
        }
    };


    export const OmisePaymentTypeAdjustment = Symbol("OmisePaymentTypeAdjustment");
    export interface OmisePaymentTypeAdjustment extends PaymentTypeAdjustment {
        [OmisePaymentTypeAdjustment]: boolean;
        FeeAmount: number;
    }

    export function isOmisePaymentTypeAdjustment(val: PaymentTypeAdjustment): val is OmisePaymentTypeAdjustment {
        return val && (val as OmisePaymentTypeAdjustment)[OmisePaymentTypeAdjustment] === true;
    }

    export interface OmisePaymentTypeAdjustmentValueDto extends PaymentTypeAdjustmentValueDto {
        feeAmount: number;
    }

    export const OmisePaymentTypeAdjustmentDefinition: PaymentTypeAdjustmentDefinition = {
        key: "Omise",
        name: "Omise",
        isInstanceOf: (paymentTypeAdjustment: PaymentTypeAdjustment) => isOmisePaymentTypeAdjustment(paymentTypeAdjustment),
        create: (): OmisePaymentTypeAdjustment => {
            return {
                [PaymentTypeAdjustment]: true,
                [OmisePaymentTypeAdjustment]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentTypeAdjustment: OmisePaymentTypeAdjustment): OmisePaymentTypeAdjustmentValueDto => {
            return {
                feeAmount: paymentTypeAdjustment.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeAdjustmentDefinition, dto: OmisePaymentTypeAdjustmentValueDto) {
            const omise = this.create() as OmisePaymentTypeAdjustment;
            omise.FeeAmount = dto.feeAmount;
            return omise;
        }
    };



    export const TwoC2PPaymentTypeAdjustment = Symbol("TwoC2PPaymentTypeAdjustment");
    export interface TwoC2PPaymentTypeAdjustment extends PaymentTypeAdjustment {
        [TwoC2PPaymentTypeAdjustment]: boolean;
        FeeAmount: number;
    }

    export function isTwoC2PPaymentTypeAdjustment(val: PaymentTypeAdjustment): val is TwoC2PPaymentTypeAdjustment {
        return val && (val as TwoC2PPaymentTypeAdjustment)[TwoC2PPaymentTypeAdjustment] === true;
    }

    export interface TwoC2PPaymentTypeAdjustmentValueDto extends PaymentTypeAdjustmentValueDto {
        feeAmount: number;
    }

    export const TwoC2PPaymentTypeAdjustmentDefinition: PaymentTypeAdjustmentDefinition = {
        key: "TwoC2P",
        name: "2C2P",
        isInstanceOf: (paymentTypeAdjustment: PaymentTypeAdjustment) => isTwoC2PPaymentTypeAdjustment(paymentTypeAdjustment),
        create: (): TwoC2PPaymentTypeAdjustment => {
            return {
                [PaymentTypeAdjustment]: true,
                [TwoC2PPaymentTypeAdjustment]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentTypeAdjustment: TwoC2PPaymentTypeAdjustment): TwoC2PPaymentTypeAdjustmentValueDto => {
            return {
                feeAmount: paymentTypeAdjustment.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeAdjustmentDefinition, dto: TwoC2PPaymentTypeAdjustmentValueDto) {
            const twoC2P = this.create() as TwoC2PPaymentTypeAdjustment;
            twoC2P.FeeAmount = dto.feeAmount;
            return twoC2P;
        }
    };


    export const WisePaymentTypeAdjustment = Symbol("WisePaymentTypeAdjustment");
    export interface WisePaymentTypeAdjustment extends PaymentTypeAdjustment {
        [WisePaymentTypeAdjustment]: boolean;
        FeeAmount: number;
    }

    export function isWisePaymentTypeAdjustment(val: PaymentTypeAdjustment): val is WisePaymentTypeAdjustment {
        return val && (val as WisePaymentTypeAdjustment)[WisePaymentTypeAdjustment] === true;
    }

    export interface WisePaymentTypeAdjustmentValueDto extends PaymentTypeAdjustmentValueDto {
        feeAmount: number;
    }

    export const WisePaymentTypeAdjustmentDefinition: PaymentTypeAdjustmentDefinition = {
        key: "Wise",
        name: "Wise",
        isInstanceOf: (paymentTypeAdjustment: PaymentTypeAdjustment) => isWisePaymentTypeAdjustment(paymentTypeAdjustment),
        create: (): WisePaymentTypeAdjustment => {
            return {
                [PaymentTypeAdjustment]: true,
                [WisePaymentTypeAdjustment]: true,
                FeeAmount: 0
            };
        },
        serialize: (paymentTypeAdjustment: WisePaymentTypeAdjustment): WisePaymentTypeAdjustmentValueDto => {
            return {
                feeAmount: paymentTypeAdjustment.FeeAmount
            };
        },
        deserialize: function (this: PaymentTypeAdjustmentDefinition, dto: WisePaymentTypeAdjustmentValueDto) {
            const wise = this.create() as WisePaymentTypeAdjustment;
            wise.FeeAmount = dto.feeAmount;
            return wise;
        }
    };


    interface PaymentTypeAdjustmentDefinition {
        key: string;
        name: string;
        isInstanceOf: (paymentTypeAdjustment: PaymentTypeAdjustment) => boolean;
        create: () => PaymentTypeAdjustment;
        serialize: (paymentTypeAdjustment: PaymentTypeAdjustment) => PaymentTypeAdjustmentValueDto;
        deserialize: (dto: PaymentTypeAdjustmentValueDto) => PaymentTypeAdjustment;
    }

    interface PaymentTypeAdjustmentDefinitionT<T, TDto> extends Omit<PaymentTypeAdjustmentDefinition, 'create' | 'serialize' | 'deserialize'> {
        create: () => T;
        serialize: (paymentTypeAdjustment: T) => TDto;
        deserialize: (dto: TDto) => T;
    }

    const paymentTypeAdjustments: PaymentTypeAdjustmentDefinition[] = [
        StripePaymentTypeAdjustmentDefinition,
        OmisePaymentTypeAdjustmentDefinition,
        TwoC2PPaymentTypeAdjustmentDefinition,
        WisePaymentTypeAdjustmentDefinition
    ]

}
